import React, { useContext, useEffect, useState } from "react";
import { Pie } from "react-chartjs-2";
import { MDBContainer } from "mdbreact";
import StateContext from "../../StateContext";
import { firestore } from "../../firebase";

const EKDonutChart = () => {

    const appState = useContext(StateContext)

    const [data, setData] = useState([]);
    const [labels, setLabels] = useState([]);

    useEffect(() => {

        if (appState.userId) {
            try {
                const ekRef = firestore.collection("users").doc(appState.userId).collection("egenkapital");
                ekRef.onSnapshot(({docs}) => {
                    const ek = docs.map(doc => {
                        return {id: doc.id, ...doc.data()};
                    });
                    const data = ek.map(sum => {
                        return +sum.sum;
                    });
                    const labels = ek.map(label => {
                        return label.konto;
                    })
                    setData(data);
                    setLabels(labels)
                })
            } catch (error) {
                console.log(error);
            }
        }

    }, [appState.userId])

    const state = {
        dataPie: {
        labels: labels,
        datasets: [
            {
            data: data,
            backgroundColor: [
                "#F7464A",
                "#46BFBD",
                "#FDB45C",
                "#949FB1",
                "#4D5360",
                "#AC64AD",
                "#F7464A",
                "#46BFBD",
                "#FDB45C",
                "#949FB1",
                "#4D5360",
                "#AC64AD"
            ],
            hoverBackgroundColor: [
                "#FF5A5E",
                "#5AD3D1",
                "#FFC870",
                "#A8B3C5",
                "#616774",
                "#DA92DB",
                "#FF5A5E",
                "#5AD3D1",
                "#FFC870",
                "#A8B3C5",
                "#616774",
                "#DA92DB"
            ]
            }
        ]
        }
    }



    return (
        <MDBContainer>         
            <h3 className="mt-5">Egenkapital</h3>
            <Pie data={state.dataPie} options={{ responsive: true }} />
        </MDBContainer>
    );

}

export default EKDonutChart;